import React, {useEffect, useState} from 'react';
import styles from "./AttachedEvents.module.scss";
import {Button, Status} from "uikit";
import {
    AttachedEventsPropsInterface
} from "@/views/Admin/Events/Event/Promocodes/AttachedEvents/AttachedEvents.props.interface";
import {AttachedEventsSchema} from "@/views/Admin/Events/Event/Promocodes/AttachedEvents/AttachedEvents.schema";
import ArrowDownIcon from '@/assets/images/icons/12/arrow-down.svg';
import {
    PromocodeRelatedEventInterface,
    PromocodeTicketsInterface
} from "@/views/Admin/Events/Event/Promocodes/AttachedEvents/AttachedEvents.interface";
import AttachEventsModal from "@/views/Admin/Events/Event/Promocodes/AttachEventsModal/AttachEventsModal";
import {EventBasesServiceInterface} from "@/services/EventBasesService/EventBasesService.interface";
import {TicketInterface} from "@/types/Ticket.interface";
import {getUniqueEvents} from "@/views/Admin/Events/Event/Promocodes/AttachEventsModal/AttachEventsModal.internal";
import {useTranslation} from "react-i18next";
import {EventStateSchema} from "@/schema/EventState.schema";

const AttachedEvents = ({data, onChange, initialPromocodes}: AttachedEventsPropsInterface) => {
    const [eventContent, setEventContent] = useState<PromocodeTicketsInterface>({
        ...AttachedEventsSchema,
        promocodeId: initialPromocodes.length > 0 ? initialPromocodes.map(promocode => Number(promocode.id)) : data.id,
        initialPromocodeEvent: initialPromocodes.length > 0
            ? getUniqueEvents(initialPromocodes.map(promocode => promocode.event))
            : [data.event]
    })
    const [modal, setModal] = useState(false);
    const {t} = useTranslation('common');

    useEffect(() => {
        const mainEvents = eventContent.initialPromocodeEvent.map(processEvent).filter(Boolean);
        const foreignEvents = data.foreignEvents?.map(processEvent).filter(Boolean) || [];

        setEventContent(prev => ({
            ...prev,
            relatedEvents: [
                ...mainEvents,
                ...foreignEvents
            ]
        }));
    }, [data.foreignEvents, eventContent.initialPromocodeEvent, data.tickets]);

    const processEvent = (event: EventBasesServiceInterface) => {
        if (!event) return null;

        const linkedTicketsForEvent = (data.tickets || [])
            .filter(linkedTicket => linkedTicket && String(linkedTicket.eventId) === String(event.eventId))
            .map(linkedTicket => String(linkedTicket.ticketId));

        const visibleTickets = linkedTicketsForEvent.length > 0
            ? event.tickets.filter(ticket => linkedTicketsForEvent.includes(String(ticket.id)))
            : event.tickets;

        return {
            ...event,
            isExpand: false,
            tickets: visibleTickets
        };
    };

    const handleCallModal = (e: React.ChangeEvent<HTMLButtonElement>) => {
        e.preventDefault()

        setModal(prev => !prev)
    }

    const handleExpandTickets = (id: number) => {
        setEventContent(prev => ({
            ...prev,
            relatedEvents: prev.relatedEvents.map(relatedEvent =>
                id === relatedEvent.id ? {...relatedEvent, isExpand: !relatedEvent.isExpand} : relatedEvent
            )
        }))
    }

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>
                {t('tickets')}
            </h3>
            <div className={styles.control}>
                <p>
                    {t('Промокод доступен для следующих событий и билетов')}
                </p>
                <Button
                    theme={'default'}
                    type={'secondary'}
                    size={'small'}
                    htmlType={'button'}
                    disabled={!eventContent.promocodeId}
                    onClick={handleCallModal}>
                    {t('set')}
                </Button>
            </div>
            <div className={styles.events}>
                {eventContent.promocodeId && eventContent.relatedEvents.map((relatedEvent: PromocodeRelatedEventInterface) =>
                    <div key={relatedEvent.id}>
                        <div className={styles.event}>
                            <div className={styles.infoWrapper}>
                                <div className={styles.info}>
                                    <p>
                                        {relatedEvent.eventTitle}
                                    </p>
                                    <small>
                                        {relatedEvent.dateWithTimezone}
                                    </small>
                                </div>
                                <Status
                                    type={EventStateSchema[relatedEvent.state].type}
                                    data={null}
                                    onChange={() => null}
                                    size={'small'}>
                                    {EventStateSchema[relatedEvent.state].value}
                                </Status>
                            </div>
                            <div className={
                                [
                                    styles.counter,
                                    relatedEvent.isExpand && styles.expand
                                ].filter(Boolean).join(' ')}
                                 onClick={() => handleExpandTickets(relatedEvent.id)}>
                                <span>
                                    {relatedEvent.tickets.length}
                                </span>
                                <ArrowDownIcon/>
                            </div>
                        </div>
                        <div
                            className={[styles.tickets, relatedEvent.isExpand ? styles.opened : null].filter(x => x ?? x).join(' ')}>
                            {relatedEvent.tickets
                                .map((ticket: TicketInterface) => <p
                                    key={ticket.id}
                                    className={styles.ticket}>
                                    {ticket.name}
                                </p>)
                            }
                        </div>
                    </div>
                )}
            </div>
            <AttachEventsModal
                data={eventContent}
                onChange={onChange}
                active={modal}
                onActive={setModal}
            />
        </div>
    );
};

export default AttachedEvents;
